/**
 * 空文字→undefinedに変換
 * @param param 空文字が想定される値
 * @return 空文字がundefinedに変換された値
 */
export const emptyStrToUndefined = (param?: string) => (param === '' ? undefined : param);
